import { Check, Smartphone } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useGame } from '../contexts/GameContext'
import { cn } from '../lib/utils'

export function RotationPrompt() {
	const { changeScreen } = useGame()
	const [isLandscape, setIsLandscape] = useState(false)

	useEffect(() => {
		const checkOrientation = () => {
			const landscape = window.innerWidth > window.innerHeight
			setIsLandscape(landscape)

			if (!landscape) {
				changeScreen('home')
			}
		}

		checkOrientation()
		window.addEventListener('resize', checkOrientation)
		window.addEventListener('orientationchange', checkOrientation)

		return () => {
			window.removeEventListener('resize', checkOrientation)
			window.removeEventListener('orientationchange', checkOrientation)
		}
	}, [])

	return (
		<div
			className={cn(
				'pointer-events-none fixed inset-0 z-[9999] flex h-dvh w-full flex-col items-center justify-center',
				'bg-zinc-500 px-8 text-white opacity-0 transition-opacity duration-300',
				{
					'opacity-100': !isLandscape,
				}
			)}
		>
			<div className="mb-8 text-center">
				<h1 className="mb-4 font-bold text-2xl">Rotacione o seu celular</h1>
				<p className="text-lg">Por favor, para jogar, posicione o seu celular na horizontal</p>
			</div>

			<div className="relative flex items-center gap-4">
				<Smartphone
					size={60}
					className={`transition-transform duration-1000 ${isLandscape ? 'rotate-90 opacity-50' : 'rotate-0'}`}
				/>
			</div>

			{isLandscape && (
				<div className="mt-8 flex animate-pulse items-center gap-2 text-green-300">
					<Check size={24} />
					Perfeito! Carregando jogo...
				</div>
			)}
		</div>
	)
}
